import { useState, useCallback, useEffect } from 'react';
import { EmailConfirmationModal } from './email-confirmation-modal.js';
import { jsx } from 'react/jsx-runtime';

const MODAL_TRIGGER_EVENT_NAME = "SHOW_EMAIL_CONFIRMATION_MODAL";
const useCustomWindowEvent = (eventName, callback) => {
  useEffect(() => {
    window.addEventListener(eventName, callback);
    return () => window.removeEventListener(eventName, callback);
  }, [eventName, callback]);
};
const EmailConfirmationModalOpenEventListener = _ref => {
  let {
    locale
  } = _ref;
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const openModal = useCallback(() => {
    setModalIsVisible(true);
  }, []);
  useCustomWindowEvent(MODAL_TRIGGER_EVENT_NAME, openModal);
  const closeModal = () => {
    setModalIsVisible(false);
  };
  return /*#__PURE__*/jsx(EmailConfirmationModal, {
    isVisible: modalIsVisible,
    onClose: closeModal,
    locale: locale
  });
};

export { EmailConfirmationModalOpenEventListener, MODAL_TRIGGER_EVENT_NAME };
//# sourceMappingURL=email-confirmation-modal-open-event-listener.js.map
